// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-SongRequests-module__youtubeVideoEmbed-LxD7E {
  flex: 1;
  overflow: hidden;
  padding: 0px;
  border: none;
}

.nightbot-SongRequests-module__soundcloudVideoEmbed-yGLru {
  max-height: 300px;
  overflow: hidden;
  padding: 0px;
  border: none;
}

.nightbot-SongRequests-module__songRequestsTablePanel-TlJwz {
  flex: 1;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom: none;
}

.nightbot-SongRequests-module__songRequestSettingsButton-IO1DT {
  width: 36px;
  height: 36px;
}

@media (max-width: 1200px) {
  .nightbot-SongRequests-module__videoPlayerBanner-j5S8c:has(.nightbot-SongRequests-module__youtubeVideoEmbed-LxD7E) {
    flex-direction: column;
    gap: 24px;
  }

    .nightbot-SongRequests-module__videoPlayerBanner-j5S8c:has(.nightbot-SongRequests-module__youtubeVideoEmbed-LxD7E) .nightbot-SongRequests-module__youtubeVideoDescription-RiQtC {
      align-self: flex-start;
    }
}

@media (max-width: 768px) {
  .nightbot-SongRequests-module__videoPlayerBanner-j5S8c:has(.nightbot-SongRequests-module__soundcloudVideoEmbed-yGLru) {
    flex-direction: column;
    gap: 24px;
  }

    .nightbot-SongRequests-module__videoPlayerBanner-j5S8c:has(.nightbot-SongRequests-module__soundcloudVideoEmbed-yGLru) .nightbot-SongRequests-module__soundcloudVideoDescription-ydl6H {
      align-self: flex-start;
    }

    .nightbot-SongRequests-module__videoPlayerBanner-j5S8c:has(.nightbot-SongRequests-module__soundcloudVideoEmbed-yGLru) .nightbot-SongRequests-module__soundcloudVideoEmbed-yGLru {
      max-height: none;
      max-height: initial;
    }
}

.nightbot-SongRequests-module__videoPlayerBanner-j5S8c {
  display: flex;
  gap: 48px;
  flex-direction: row;
}

.nightbot-SongRequests-module__videoPlayerBannerEmpty-AhBnX {
  display: none;
}

.nightbot-SongRequests-module__songRequestTableContainer-YgJSO {
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
}

.nightbot-SongRequests-module__songRequestControls-P56xD {
  position: sticky;
  bottom: 0;
  border-left-width: 1px;
  border-right-width: 1px;
  border-color: var(--border-primary);
  background-color: var(--background-primary);
  z-index: 2;
}

.nightbot-SongRequests-module__youtubeVideoDescription-RiQtC {
  flex: 1;
  align-self: center;
}

.nightbot-SongRequests-module__soundcloudVideoDescription-ydl6H {
  flex: 1;
  align-self: center;
}

.nightbot-SongRequests-module__songRequestLayout-wjIrn {
  flex: 1;
  position: relative;
  gap: 0px;
}

[data-mantine-color-scheme='dark']:root .nightbot-SongRequests-module__songRequestLayout-wjIrn {
    background: linear-gradient(to bottom, var(--thumbnailAccentColor), transparent 400px);
  }

.nightbot-SongRequests-module__songRequestContainer-cJ94A {
  padding-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/SongRequests.module.scss"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,OAAO;EACP,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EAKX;;IAHE;MACE,sBAAsB;IACxB;AAEJ;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EASX;;IAPE;MACE,sBAAsB;IACxB;;IAEA;MACE,gBAAiB;MAAjB,mBAAiB;IACnB;AAEJ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;EACnC,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,QAAQ;AACV;;AAGE;IACE,sFAAsF;EACxF;;AAGF;EACE,mBAAmB;AACrB","sourcesContent":[".youtubeVideoEmbed {\n  flex: 1;\n  overflow: hidden;\n  padding: 0px;\n  border: none;\n}\n\n.soundcloudVideoEmbed {\n  max-height: 300px;\n  overflow: hidden;\n  padding: 0px;\n  border: none;\n}\n\n.songRequestsTablePanel {\n  flex: 1;\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-bottom: none;\n}\n\n.songRequestSettingsButton {\n  width: 36px;\n  height: 36px;\n}\n\n@media (max-width: $mantine-breakpoint-lg) {\n  .videoPlayerBanner:has(.youtubeVideoEmbed) {\n    flex-direction: column;\n    gap: 24px;\n\n    .youtubeVideoDescription {\n      align-self: flex-start;\n    }\n  }\n}\n\n@media (max-width: $mantine-breakpoint-sm) {\n  .videoPlayerBanner:has(.soundcloudVideoEmbed) {\n    flex-direction: column;\n    gap: 24px;\n\n    .soundcloudVideoDescription {\n      align-self: flex-start;\n    }\n\n    .soundcloudVideoEmbed {\n      max-height: unset;\n    }\n  }\n}\n\n.videoPlayerBanner {\n  display: flex;\n  gap: 48px;\n  flex-direction: row;\n}\n\n.videoPlayerBannerEmpty {\n  display: none;\n}\n\n.songRequestTableContainer {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  position: relative;\n}\n\n.songRequestControls {\n  position: sticky;\n  bottom: 0;\n  border-left-width: 1px;\n  border-right-width: 1px;\n  border-color: var(--border-primary);\n  background-color: var(--background-primary);\n  z-index: 2;\n}\n\n.youtubeVideoDescription {\n  flex: 1;\n  align-self: center;\n}\n\n.soundcloudVideoDescription {\n  flex: 1;\n  align-self: center;\n}\n\n.songRequestLayout {\n  flex: 1;\n  position: relative;\n  gap: 0px;\n}\n\n@mixin dark-root {\n  .songRequestLayout {\n    background: linear-gradient(to bottom, var(--thumbnailAccentColor), transparent 400px);\n  }\n}\n\n.songRequestContainer {\n  padding-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"youtubeVideoEmbed": `nightbot-SongRequests-module__youtubeVideoEmbed-LxD7E`,
	"soundcloudVideoEmbed": `nightbot-SongRequests-module__soundcloudVideoEmbed-yGLru`,
	"songRequestsTablePanel": `nightbot-SongRequests-module__songRequestsTablePanel-TlJwz`,
	"songRequestSettingsButton": `nightbot-SongRequests-module__songRequestSettingsButton-IO1DT`,
	"videoPlayerBanner": `nightbot-SongRequests-module__videoPlayerBanner-j5S8c`,
	"youtubeVideoDescription": `nightbot-SongRequests-module__youtubeVideoDescription-RiQtC`,
	"soundcloudVideoDescription": `nightbot-SongRequests-module__soundcloudVideoDescription-ydl6H`,
	"videoPlayerBannerEmpty": `nightbot-SongRequests-module__videoPlayerBannerEmpty-AhBnX`,
	"songRequestTableContainer": `nightbot-SongRequests-module__songRequestTableContainer-YgJSO`,
	"songRequestControls": `nightbot-SongRequests-module__songRequestControls-P56xD`,
	"songRequestLayout": `nightbot-SongRequests-module__songRequestLayout-wjIrn`,
	"songRequestContainer": `nightbot-SongRequests-module__songRequestContainer-cJ94A`
};
export default ___CSS_LOADER_EXPORT___;
